module.exports = __webpack_public_path__ + "img/swhz.bbcb0804.png";